"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFormYandex = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
var react_router_1 = require("react-router");
var reducer_1 = require("../../store/payment/reducer");
var axios_1 = require("../../utils/axios");
var PaymentButton_1 = require("../../components/PaymentButton");
var PaymentFormYandex = function (_a) {
    var total = _a.total;
    var _b = (0, react_1.useState)(false), processing = _b[0], setProcessing = _b[1];
    var _c = (0, react_1.useState)(''), confirmationToken = _c[0], setConfirmationToken = _c[1];
    var _d = (0, react_router_1.useHistory)(), location = _d.location, push = _d.push;
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var tableQuery = searchParams.get('table') || '';
    var _e = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ({
            cart: state.cart,
            currency: (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.currency,
        });
    }), cart = _e.cart, currency = _e.currency;
    var paymentId = '';
    var yandexPaymentIntentCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var methodType, data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    methodType = reducer_1.PaymentMethodType.card;
                    data = {
                        cart: cart,
                        type: type || (tableQuery ? 'dinein' : ''),
                        restaurant_id: restaurantId,
                        currency: currency,
                        method_type: methodType,
                        payment_method_id: null,
                    };
                    return [4, (0, axios_1.post)('/api/yookassa/payment_intent', data)
                            .then(function (res) {
                            setConfirmationToken(res.data.confirmation.confirmation_token);
                            setProcessing(false);
                        })
                            .catch(function (e) {
                            var _a;
                            var message = ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || (e === null || e === void 0 ? void 0 : e.message) || 'Something went wrong';
                            react_toastify_1.toast.error(message);
                            setProcessing(false);
                        })];
                case 1:
                    response = _a.sent();
                    return [2, response];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (confirmationToken != '') {
            var checkout_1 = new window.YooMoneyCheckoutWidget({
                confirmation_token: confirmationToken,
                error_callback: function (error) {
                    setProcessing(false);
                },
            });
            checkout_1.on('success', function () { return __awaiter(void 0, void 0, void 0, function () {
                var prevParams, newParams, URLParams;
                return __generator(this, function (_a) {
                    setProcessing(false);
                    checkout_1.destroy();
                    prevParams = Object.fromEntries(searchParams);
                    newParams = __assign(__assign({}, prevParams), { type: type, key: confirmationToken });
                    URLParams = new URLSearchParams(newParams);
                    push({
                        pathname: "/store/".concat(restaurantId, "/confirm"),
                        search: URLParams.toString(),
                    });
                    return [2];
                });
            }); });
            checkout_1.on('fail', function (err) {
                setProcessing(false);
                checkout_1.destroy();
            });
            checkout_1.render('payment-form');
        }
    }, [confirmationToken]);
    var pay = function () {
        setProcessing(true);
        yandexPaymentIntentCreate();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PaymentButton_1.PaymentButton, { isDisabled: processing, total: total, pay: pay, currency: currency }), (0, jsx_runtime_1.jsx)("div", { id: "payment-form", style: { display: !confirmationToken ? 'hidden' : '' } })] }));
};
exports.PaymentFormYandex = PaymentFormYandex;
